import React, { useState, useEffect } from 'react';

import SetupStep from './SetupStep';
import QrCodeStep from './QrCodeStep';
import ManualSetupStep from './ManualSetupStep';
import VerifyCodeStep from './VerifyCodeStep';
import { FormLayout } from '../../layout';
import { WIDGET_STATES } from '../../config/widgetStates';

export const GOOGLE_MFA_STEPS = {
  SETUP: 'setup',
  QR_CODE: 'qrCode',
  MANUAL_SETUP: 'manualSetup',
  VERIFY_CODE: 'verifyCode',
};

const OKTA_STATE_TO_STEP = {
  [WIDGET_STATES.ENROLL_TOTP]: GOOGLE_MFA_STEPS.SETUP,
  [WIDGET_STATES.BARCODE_TOTP]: GOOGLE_MFA_STEPS.QR_CODE,
  [WIDGET_STATES.ACTIVATE_TOTP]: GOOGLE_MFA_STEPS.VERIFY_CODE,
  [WIDGET_STATES.ENROLL_MANUAL_TOTP]: GOOGLE_MFA_STEPS.MANUAL_SETUP,
  [WIDGET_STATES.MFA_VERIFY_GOOGLE_AUTH]: GOOGLE_MFA_STEPS.VERIFY_CODE,
};

const CustomGoogleMFA = ({
  oktaViewState,
  isVerifyMode,
  onPickDifferentMethod,
  onAdvanceEnrollment,
  onRevealManualKey,
  onVerifyCode,
  qrCodeSrc,
  manualSetupKey,
  error,
  isSubmitting,
}) => {
  const [step, setStep] = useState(() => OKTA_STATE_TO_STEP[oktaViewState] || GOOGLE_MFA_STEPS.SETUP,);

  useEffect(() => {
    const mapped = OKTA_STATE_TO_STEP[oktaViewState];
    if (mapped) setStep(mapped);
  }, [oktaViewState]);

  const handleSelectDevice = () => {
    if (onAdvanceEnrollment?.() === false) return;
    setStep(GOOGLE_MFA_STEPS.QR_CODE);
  };

  const handleQrCodeNext = () => {
    if (onAdvanceEnrollment?.() === false) return;
    setStep(GOOGLE_MFA_STEPS.VERIFY_CODE);
  };

  const handleCantScan = () => {
    if (onRevealManualKey?.() === false) return;
    setStep(GOOGLE_MFA_STEPS.MANUAL_SETUP);
  };

  const handleManualSetupNext = () => {
    if (onAdvanceEnrollment?.() === false) return;
    setStep(GOOGLE_MFA_STEPS.VERIFY_CODE);
  };

  const handleVerifyCode = (code, rememberDevice) => {
    onVerifyCode?.(code, rememberDevice);
  };

  const renderStep = () => {
    switch (step) {
      case GOOGLE_MFA_STEPS.SETUP:
        return (
          <SetupStep
            onNext={handleSelectDevice}
            onPickDifferentMethod={onPickDifferentMethod}
            isSubmitting={isSubmitting}
          />
        );
      case GOOGLE_MFA_STEPS.QR_CODE:
        return (
          <QrCodeStep
            qrCodeSrc={qrCodeSrc}
            onCantScan={handleCantScan}
            onNext={handleQrCodeNext}
            onPickDifferentMethod={onPickDifferentMethod}
            isSubmitting={isSubmitting}
          />
        );
      case GOOGLE_MFA_STEPS.MANUAL_SETUP:
        return (
          <ManualSetupStep
            manualSetupKey={manualSetupKey}
            onNext={handleManualSetupNext}
            onPickDifferentMethod={onPickDifferentMethod}
            isSubmitting={isSubmitting}
          />
        );
      case GOOGLE_MFA_STEPS.VERIFY_CODE:
        return (
          <VerifyCodeStep
            isVerifyMode={isVerifyMode}
            onVerifyCode={handleVerifyCode}
            onPickDifferentMethod={onPickDifferentMethod}
            error={error}
            isSubmitting={isSubmitting}
          />
        );
      default:
        return null;
    }
  };

  return (
    <FormLayout>
      {renderStep()}
    </FormLayout>
  );
};

export default CustomGoogleMFA;
